/* eslint-disable */
import {ReactComponent} from './ReactComponent';
import {BasePageModel} from './BasePageModel';
/**
* @description Interface for Avensia.Commerce.Web.src.views.ContentPage.ContentPageModel
*/
export interface ContentPageModel extends BasePageModel {
	content: ReactComponent[];
}
export const isContentPage = (model: unknown): model is ContentPageModel => (model as ContentPageModel).componentName === 'ContentPage';
